export const OPEN_LISTING_SEARCH_DATES_EVENT = "listing-search:open-dates"